import React from 'react';
import {PtrnTiposCampo} from '../../patronTypes';
import {CampoEditableProps} from './campoEditableTypes';
import CE_Checkbox from './CE_Checkbox';
import CE_Date from './CE_Date';
import CE_Datetime from './CE_Datetime';
import CE_Float from './CE_Float';
import CE_Int from './CE_Int';
import CE_Radio from './CE_Radio';
import CE_Select from './CE_Select';
import CE_String from './CE_String';
import CE_Switch from './CE_Switch';
import CE_Time from './CE_Time';
import CE_SelectCheckbox from './CE_SelectCheckbox';
import CE_Formula from './CE_Formula';
import CG_Button from '../CampoOtros/CG_Button';
const ComponentMap = {
   [PtrnTiposCampo.string]: CE_String,
   [PtrnTiposCampo.int]: CE_Int,
   [PtrnTiposCampo.float]: CE_Float,
   [PtrnTiposCampo.date]: CE_Date,
   [PtrnTiposCampo.time]: CE_Time,
   [PtrnTiposCampo.datetime]: CE_Datetime,
   [PtrnTiposCampo.switch]: CE_Switch,
   [PtrnTiposCampo.checkbox]: CE_Checkbox,
   [PtrnTiposCampo.select]: CE_Select,
   [PtrnTiposCampo.radio]: CE_Radio,
   [PtrnTiposCampo.selectCheckbox]: CE_SelectCheckbox,
   [PtrnTiposCampo.boton]: CG_Button,
   [PtrnTiposCampo.formula]: CE_Formula
};

function CampoEditableItem(props: CampoEditableProps & {ErrorComponent?: React.ReactNode}) {
   const {campoConfig, ...editableProps} = props;
   // @ts-ignore ignorar error de tipado para poder usar ComponentMap con las propiedades campoConfig y editableProps
   const ComponenteTipo = ComponentMap[campoConfig.tipo];
   if (!ComponenteTipo) {
      console.warn();
      return (
         <div>
            componente de tipo "{campoConfig.tipo}" y nombre "{campoConfig.name}" no definido
         </div>
      );
   }

   return <ComponenteTipo campoConfig={campoConfig} {...editableProps} />;
}

export default CampoEditableItem;
